import { render, staticRenderFns } from "./DesignatedPositionCompletionModal.vue?vue&type=template&id=36e0f784&scoped=true"
import script from "./DesignatedPositionCompletionModal.vue?vue&type=script&lang=js"
export * from "./DesignatedPositionCompletionModal.vue?vue&type=script&lang=js"
import style0 from "./DesignatedPositionCompletionModal.vue?vue&type=style&index=0&id=36e0f784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0f784",
  null
  
)

export default component.exports